import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {AuthService} from '../../../../autenticacion/servicios/auth.service';
import {ConsumerService} from '../../../recursos/servicio/consumer.service';
import {WebServices} from '../../../recursos/modelo/consumerModel/web-services.enum';
import {UtilConfig} from '../../../../autenticacion/servicios/UtilConfig';
import {Router} from '@angular/router';
import * as moment from 'moment';
import {Observable} from '../../../../../../node_modules/rxjs/Observable';
import {map, startWith} from '../../../../../../node_modules/rxjs/operators';
import {MatSnackBar} from '@angular/material';

declare var $: any;
declare var swal: any;

@Component({
    selector: 'app-baja-documento',
    templateUrl: './view/baja-documento.component.html',
    styleUrls: ['./css/baja-documento.component.scss'],
    providers: [AuthService, ConsumerService]
})
export class BajaDocumentoComponent implements OnInit {

    @Input() documento;
    IGV = 18.0;
    loading = false;
    overload_descripcion = false;
    overload_item = false;
    loadingConsultas = [
        {
            modulo: 'Cargando detalle documento',
            cargando: true
        }
    ];
    mensaje = '';
    error = false;
    formBajaDocumento: FormGroup;
    vld_serie: FormControl;
    vld_motivo: FormControl;
    serie: String;
    tipo: any;
    motivo: String;
    nota: any;
    tipoDoc = 'RA';
    usuarioSession: any;
    options: String[] = [];
    filteredOptions: Observable<String[]>;
    myControl = new FormControl();
    settings: any;

    data: any[] = [];
    dataRetention: any;
    datosBk: any[];

    constructor(private util: UtilConfig,
                private fb: FormBuilder,
                private router: Router,
                private snackBar: MatSnackBar,
                private consumerService: ConsumerService) {
        this.usuarioSession = this.util.getCurrentUser();
        this.IGV = this.usuarioSession.customer.igv || 18.0;
        this.createFormControls();
        this.createFormBajaDocumento();
    }

    ngOnInit(): void {
        this.filteredOptions = this.myControl.valueChanges
            .pipe(
                startWith(''),
                map(value => this._filter(value))
            );
        if (this.documento.documentType != 'CREDIT_NOTE' && this.documento.documentType != 'DEBIT_NOTE' && this.documento.documentType != 'RETENTION') {
            this.getDetalleFactura();
        } else {
            this.loadingConsultas[0].cargando = false;
        }
    }


    createFormControls() {
        this.vld_serie = new FormControl({value: ''}, [Validators.required]);
        this.vld_motivo = new FormControl({value: ''}, [Validators.required]);

    }

    createFormBajaDocumento() {
        this.formBajaDocumento = this.fb.group({
            'serie': this.vld_serie,
            'motivo': this.vld_motivo
        });

    }

    onSubmitBajaDocumento() {
        this.error = false;
        this.mensaje = '';
        if (this.formBajaDocumento.valid) {
            this.generarDocumentoBajaDocumento()
        } else {
            swal(
                'Campos obligatorios',
                'Debe completar todo los campos con (*)',
                'error'
            );
        }
    }

    generarDocumentoBajaDocumento() {
        let body: any = {
            id: this.documento.id,
            customer: {
                ruc: this.documento.numRuc
            }
        };
        let peticion: any = {
            ide: {},
            emi: {
                tipoDocId: 6,
                numeroDocId: this.documento.numRuc,
                nombreComercial: '',
                razonSocial: '',
                direccion: '',
            }
        };

        let rcOrra;

        if (this.documento.documentType === 'RETENTION') {
            body = this.completeBodyRR(peticion, body, '20');
            rcOrra = 'RR';
        } else if (this.documento.documentType === 'INVOICE') {
            body = this.completeBodyRA(peticion, body, '01');
            rcOrra = 'RA';
        } else if (this.documento.documentType === 'TICKET') {
            body = this.completeBodyRC(peticion, body, '03');
            rcOrra = 'RC';
        } else if (this.documento.documentType === 'CREDIT_NOTE' || this.documento.documentType === 'DEBIT_NOTE') {
            if (this.documento.docRefType === '01') {
                body = this.completeBodyRA(peticion, body, this.documento.documentType === 'CREDIT_NOTE' ? '07' : '08');
                rcOrra = 'RA';
            } else if (this.documento.docRefType === '03') {
                body = this.completeBodyRC(peticion, body, this.documento.documentType === 'CREDIT_NOTE' ? '07' : '08');
                rcOrra = 'RC';
            }
        }
        this.loading = true;
        this.consumerService.create(WebServices.URL_GENERAR_DOCUMENTOS, body)
            .subscribe(result => {
                this.loading = false;
                if (result.codigo != 1) {
                    swal(
                        'No se pudo crear la baja de documento ',
                        result.mensaje,
                        'error'
                    );
                } else {
                    swal({
                        title: 'baja de documento  creada',
                        text: 'Fue creada exitosamente la baja de documento . Refrescando lista.',
                        type: 'success',
                        showCancelButton: false,
                        showConfirmButton: false,
                        timer: 3000
                    });

                    setTimeout(() => {

                        var filtroList: any = {};
                        var rangeDates: Date[];
                        // RANGO FECHA
                        rangeDates = [new Date(), new Date()];
                        filtroList.tipoFecha = 'SUBIDA';
                        filtroList.inicio = moment(rangeDates[0]).format('MM/DD/YYYY');
                        filtroList.fin = moment(rangeDates[1]).format('MM/DD/YYYY');
                        filtroList.documentType = (rcOrra === 'RC') ? 'SUMMARY_DOCUMENT' : (rcOrra === 'RA') ? "RA_VOIDED_DOCUMENT" : "RR_VOIDED_DOCUMENT";
                        filtroList.estadoRegistro = 'TODAS';

                        filtroList.search = '1';
                        $('ul#slide-out').removeClass('open');
                        $('i.cerrarAleta').removeClass('open');
                        $('.closePopupNotaDebito').click();
                        this.router.navigate(['/content', {outlets: {'second': ['logEmisorV2', filtroList]}}]);
                    }, 2000);
                }


            }, err => {
                this.loading = false;
                this.util.abrirModalErrorParaServicios(err, 'No se pudo crear el documento', this.router)
            });

    }

    private completeBodyRC(peticion: any, body: any, type: string) {
        peticion.ide.fechaReferencia = this.documento.fechaEmisionCPE;
        peticion.det = [
            {
                numeroItem: 1,
                monedaItem: this.documento.codMoneda,
                numeracionItem: this.documento.numSerieCPE + '-' + this.documento.numCPE,
                tipoComprobanteItem: type,
                numeroDocIdAdq: this.documento.receptorRuc,
                tipoDocIdAdq: '',
                serieCorrelativoMod:this.documento.docRefNumber,
                tipoComprobanteMod:this.documento.docRefType,
                estadoItem: '3',
                importeTotal: this.documento.montoImporte,
                gravadas: '',
                totalImpuestos: '',
            }
        ];
        peticion = this.util.removeAllBlankOrNull_asString(peticion);
        body.documentType = 'RC';
        body.summaryDocumentTemplate = {
            resumenComprobantes: peticion
        };
        return body;
    }

    private completeBodyRA(peticion: any, body: any, type: string) {
        peticion.dbr = [
            {
                numeroItem: 1,
                tipoComprobanteItem: type,
                serieItem: this.documento.numSerieCPE,
                correlativoItem: this.documento.numCPE,
                motivoBajaItem: this.motivo
            },
        ];
        peticion.cbr = {
            fechaReferencia: this.documento.fechaEmisionCPE
        }
        peticion = this.util.removeAllBlankOrNull_asString(peticion);
        body.documentType = 'RA';
        body.voidedDocumentTemplate = {
            comunicacionBaja: peticion,
        };
        return body;
    }

    private completeBodyRR(peticion: any, body: any, type: string) {
        peticion.dbr = [
            {
                numeroItem: 1,
                tipoComprobanteItem: type,
                serieItem: this.documento.numSerieCPE,
                correlativoItem: this.documento.numCPE,
                motivoBajaItem: 'ANULADO'
            },
        ];
        peticion.cbr = {
            fechaReferencia: this.documento.fechaEmisionCPE
        }
        peticion = this.util.removeAllBlankOrNull_asString(peticion);
        body.documentType = 'RR';
        body.reversionSummaryTemplate = {
            resumenReversion: peticion,
        };
        return body;
    }

    pad(num: Number, size: number): string {
        let s = num + '';
        while (s.length < size) s = '0' + s;
        return s;
    }

    getDetalleFactura() {
        let body = {id: this.documento.id};
        this.loadingConsultas[0].cargando = true;
        this.consumerService.post(WebServices.URL_OBTENER_DETALLE, body).subscribe(result => {
            this.data = result['productsStocks'];
            $.each(this.data, function (pos, item) {
                item.selected = false;
                item.invoicedQuantity = parseFloat(item.invoicedQuantity).toFixed(3);
                item.lineExtensionAmount = parseFloat(item.lineExtensionAmount).toFixed(2);
                item.unitPrice = parseFloat(item.unitPrice).toFixed(2);
            });
            this.datosBk = JSON.parse(JSON.stringify(result['productsStocks']));
            $.each(this.datosBk, function (pos, item) {
                item.selected = false;
                item.invoicedQuantity = parseFloat(item.invoicedQuantity).toFixed(3);
                item.lineExtensionAmount = parseFloat(item.lineExtensionAmount).toFixed(2);
                item.unitPrice = parseFloat(item.unitPrice).toFixed(2);
            });
            this.loadingConsultas[0].cargando = false;
        }, err => {
            this.loadingConsultas[0].cargando = false;
            this.util.abrirModalErrorParaServicios(err, 'Error', this.router)
        });
    }

    getDetalleRetencion() {
        let body = {id: this.documento.id};
        this.loadingConsultas[0].cargando = true;
        this.consumerService.post(WebServices.URL_OBTENER_DETALLE_RETENTION, body).subscribe(result => {
            this.dataRetention = result['retentionDetails'];

            this.loadingConsultas[0].cargando = false;
        }, err => {
            this.loadingConsultas[0].cargando = false;
            this.util.abrirModalErrorParaServicios(err, 'Error', this.router)
        });
    }


    ocultarOverload() {
        this.overload_item = false;
        this.overload_descripcion = false;
    }

    clickPrevent(event) {
        event.stopPropagation();
    }

    evitarCaracteresEspeciales(event) {
        if (event.which == 189 || event.which == 69)
            return false;
    }

    private _filter(value: string): String[] {
        const filterValue = value.toLowerCase();
        return this.options.filter(option => option.toLowerCase().includes(filterValue));
    }

}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/emisorFacturas/bajaDocumento/baja-documento.component.ts